export default __webpack_public_path__ + "static/media/step8.26e6e23d.png";